import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { RouteMonitor } from "@nordpoolgroup/nps-angular-2-common";
import { RequestSSOLoginComponent } from "@nordpoolgroup/nps-angular-2-common";
import { ConcludeSSOLoginComponent } from "@nordpoolgroup/nps-angular-2-common";
import { UnauthorizedAccessComponent } from "@nordpoolgroup/nps-angular-2-common";

import { MainViewComponent } from "./MainView/MainViewComponent";
import { ContractManagementComponent } from "./ContractManagement/ContractManagementComponent";

const routes: Routes = [

    {
        path: "",
        redirectTo: "/contractmanagement",
        pathMatch: "full"
    },
    {
        path: "login",
        component: RequestSSOLoginComponent
    },
    {
        path: "oauthcallback",
        component: ConcludeSSOLoginComponent
    },
    {
        path: "unauthorized",
        component: UnauthorizedAccessComponent
    }
    ,
    {
        path: "contractmanagement",
        component: MainViewComponent,
        canActivate: [RouteMonitor],
        children: [
            { path: "", component: ContractManagementComponent }
        ]
    },
    {
        path: "oauthcallback/access_token",
        redirectTo: "/contractmanagement",
        pathMatch: "full"
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    providers: [RouteMonitor],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/AppRoutingModule.ts